import { Card, CardContent, Tooltip } from "@mui/material";
import { DateTime } from "luxon";

const categorizeChats = (allConversations) => {
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);
  const sevenDaysAgo = new Date();
  sevenDaysAgo.setDate(today.getDate() - 7);
  const thirtyDaysAgo = new Date();
  thirtyDaysAgo.setDate(today.getDate() - 30);

  const categories = {
    Today: [],
    Yesterday: [],
    "Previous 7 Days": [],
    Older: [],
  };

  allConversations.forEach((conversation) => {
    const updatedAt = DateTime.fromISO(
      new Date(conversation.updated_at).toISOString()
    );
    const now = DateTime.now();
    const today = now.startOf("day");
    const yesterday = today.minus({ days: 1 });
    const lastWeek = today.minus({ days: 7 });
    if (updatedAt >= today) {
      categories["Today"].push(conversation);
    } else if (updatedAt >= yesterday) {
      categories["Yesterday"].push(conversation);
    } else if (updatedAt >= lastWeek) {
      categories["Previous 7 Days"].push(conversation);
    } else {
      categories["Older"].push(conversation);
    }
  });

  return categories;
};

const TimeCategorizedChatList = ({
  allConversations,
  onSelectConversation,
}) => {
  const categorizedChats = categorizeChats(allConversations);

  return (
    <div>
      {Object.entries(categorizedChats).map(([category, chats]) => (
        <div key={category}>
          {chats.length > 0 && (
            <>
              <h6 style={{ textAlign: "left", marginLeft: "5px" }}>
                {category}
              </h6>

              {chats.map((chat) => (
                <Card
                  key={chat.conversation_id}
                  sx={{
                    margin: "15px",
                    minWidth: "80px",
                    paddingRight: "20px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    marginBottom: "10px",
                    whiteSpace: "nowrap",
                    cursor: "pointer",
                    boxShadow: "2px 2px 6px rgba(132, 148, 178, 0.69)",
                    transition: "all 0.3s ease-in-out",
                    "&:hover": {
                      boxShadow:
                        "2px 2px 6px rgba(96, 126, 183, 0.78), inset 0.14em 0.14em rgba(29, 161 ,242, 0.69)",
                    },
                  }}
                  onClick={() => onSelectConversation(chat.conversation_id)}
                >
                  <Tooltip title={chat.title} arrow>
                    <CardContent
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <p
                        style={{
                          fontSize: "0.8rem",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          margin: 0,
                        }}
                      >
                        {chat.title}
                      </p>
                    </CardContent>
                  </Tooltip>
                </Card>
              ))}
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default TimeCategorizedChatList;
